import smoothScroll from 'smoothscroll-polyfill'
smoothScroll.polyfill()
